module.exports = __webpack_public_path__ + "static/img/materials20.ec47dd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials20.png
// module id = VD9d
// module chunks = 2